// extracted by mini-css-extract-plugin
export default {"containerBody":"User_containerBody__TpogK"};